import React from "react";
import { Instagram, Linkedin, Facebook } from "lucide-react";

const channels = [
  {
    label: "Instagram",
    handle: "@ascendpropertyuk",
    cta: "Follow",
    href: "https://instagram.com/ascendpropertyuk",
    Icon: Instagram,
    testid: "social-link-instagram",
  },
  {
    label: "Facebook",
    handle: "@ascendpropertygroup",
    cta: "Follow",
    href: "https://www.facebook.com/ascendpropertygroup",
    Icon: Facebook,
    testid: "social-link-facebook-group",
  },
  {
    label: "Facebook",
    handle: "@ascendbuyshouses",
    cta: "Follow",
    href: "https://www.facebook.com/AscendBuysHouses",
    Icon: Facebook,
    testid: "social-link-facebook-buys",
  },
  {
    label: "LinkedIn",
    handle: "@ascendproperty",
    cta: "Follow",
    href: "https://www.linkedin.com/company/ascend-property",
    Icon: Linkedin,
    testid: "social-link-linkedin",
  },
];

export function Social() {
  return (
    <section
      id="connect"
      data-testid="social-section"
      className="bg-[var(--navy)] text-[var(--ivory)] grain-overlay py-20 lg:py-24 border-t border-[rgba(201,168,76,0.18)]"
    >
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10 text-center">
        <div className="reveal max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[var(--gold)]" />
            <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold)]">
              Stay Connected
            </span>
            <span className="h-px w-10 bg-[var(--gold)]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1]">
            Follow the journey.
            <br />
            <span className="italic text-[var(--gold)]">Insight, deals & behind-the-scenes.</span>
          </h2>
          <p
            className="mt-6 text-[1rem] max-w-xl mx-auto leading-relaxed"
            style={{ color: "rgba(245,240,232,0.75)" }}
          >
            You can connect with us across most popular social media networks —
            follow us on Instagram, Facebook &amp; LinkedIn for property insight,
            market updates, and a look behind the scenes of how we source.
          </p>
        </div>

        <div className="reveal mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 max-w-4xl mx-auto">
          {channels.map(({ label, handle, href, Icon, testid, cta }) => (
            <a
              key={`${label}-${handle}`}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={testid}
              className="group block border border-[rgba(201,168,76,0.25)] hover:border-[var(--gold)] bg-[var(--navy-2)] p-6 transition-colors"
            >
              <div className="flex items-center justify-center w-12 h-12 mx-auto rounded-full border border-[rgba(201,168,76,0.4)] text-[var(--gold)] group-hover:bg-[var(--gold)] group-hover:text-[var(--navy)] transition-colors">
                <Icon size={18} />
              </div>
              <p
                className="mt-5 font-display text-[1.25rem]"
                style={{ color: "#F5F0E8" }}
              >
                {label}
              </p>
              <p className="mt-1 text-[0.7rem] sm:text-[0.74rem] tracking-[0.1em] uppercase text-[var(--gold)]/85 break-words px-1">
                {handle}
              </p>
              <p className="mt-4 text-[0.7rem] tracking-[0.24em] uppercase text-[var(--ivory)]/55 group-hover:text-[var(--gold)] transition-colors">
                {cta} →
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
